// Frontend env shim — all build-time switches live here so the rest of the
// codebase doesn't reach into `import.meta.env` directly. Anything prefixed
// with VITE_ becomes a string at build time.

interface AppEnv {
  /** Base URL to the admin HTTP server. Empty = use vite proxy in dev. */
  apiBase: string;
  /** Grafana dashboard URL — exposed by the Dashboard "view details" link. */
  grafanaUrl: string;
}

const raw = import.meta.env;

export const env: AppEnv = {
  apiBase: (raw.VITE_TOULIU_ADMIN_API_BASE as string | undefined) || '',
  grafanaUrl:
    (raw.VITE_TOULIU_GRAFANA_URL as string | undefined) ||
    'http://grafana.touliu.local/d/touliu-overview',
};
